// extracted by mini-css-extract-plugin
export default {"cp-main-container":"ManageProject__cp-main-container__a2e1137b8be3f544de2a","cpMainContainer":"ManageProject__cp-main-container__a2e1137b8be3f544de2a"};